import { render, staticRenderFns } from "./event-calendar.vue?vue&type=template&id=b7c22c1a&scoped=true"
import script from "./event-calendar.vue?vue&type=script&lang=js"
export * from "./event-calendar.vue?vue&type=script&lang=js"
import style0 from "./event-calendar.vue?vue&type=style&index=0&id=b7c22c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c22c1a",
  null
  
)

export default component.exports